import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9536caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "category" }
const _hoisted_4 = ["data-id", "onClick"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "add-content" }
const _hoisted_7 = { class: "g-card add-form" }
const _hoisted_8 = { class: "form-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "商品名称")
], -1))
const _hoisted_10 = { class: "form-item-input" }
const _hoisted_11 = { class: "form-item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "商品单价")
], -1))
const _hoisted_13 = { class: "form-item-input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-input-tip" }, "(币种：人民币）", -1))
const _hoisted_15 = { class: "form-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("text", null, "物品数量")
], -1))
const _hoisted_17 = { class: "form-item-input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "温馨提示："),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" 请如实填写物品名、数量、价值等信息，填写单价和数量时注意单价=总价/数量，若有多种类托寄物请分开填写，物品名称需要体现物品的属性，如“红色针织上衣”，如有品牌需加上品牌名称。 "),
    /*#__PURE__*/_createElementVNode("span", { class: "reminder" }, "如因申报不符造成的查验延误和相关费用，由客户自行承担。")
  ])
], -1))
const _hoisted_19 = { class: "footer-ctrl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item", { 'is-active': _ctx.selectedCategoryId == item.id }]),
            "data-id": item.id,
            key: item.id,
            onClick: ($event: any) => (_ctx.selectedCategory(item))
          }, [
            _createVNode(_component_Icon, {
              class: "icon",
              style: _normalizeStyle({ color: item.color }),
              icon: item.icon
            }, null, 8, ["style", "icon"]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              type: "text",
              "placeholder-class": "g-input__placeholder",
              placeholder: "请详细填写物品名称，如长袖针织衫",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name_cn) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.name_cn]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input",
              type: "number",
              "placeholder-class": "g-input__placeholder",
              placeholder: "请如实填写物品价格",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.price) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.price]
            ])
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input-number g-input",
              type: "number",
              min: "1",
              placeholder: "请填写物品数量",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.quantity) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.quantity]
            ])
          ])
        ])
      ])
    ]),
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", {
        class: "g-button add-btn",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.router.back()))
      }, "返回"),
      _createElementVNode("div", {
        class: "g-button next-btn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
      }, "确认")
    ])
  ]))
}